import React from 'react';
import ReactDOM from 'react-dom/client';
import './src/index.css';
import './src/consoleLogger'; // Add console logging to terminal
import './src/i18n';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);